<template>
    <section aria-label="Key features" class="mx-auto max-w-screen-xl mb-20 px-4">
        <!-- Icon -->
        <div class="max-w-max mx-auto relative mb-8">
            <NuxtImg src="/images/circuit.png" width="298" height="180" alt="Shopping Bag"
                class="w-40 sm:w-56 md:w-72 lg:w-[298px] h-auto" loading="lazy" />
            <div
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-2xl bg-[image:var(--primary-gradient)]">
                <!-- <NsNuxtLogo class="w-6 sm:w-8 md:w-10 h-auto" /> -->
                <NsLogo name="NsNuxtLogoVector" class="w-6 sm:w-8 md:w-10 h-auto" />
            </div>
        </div>

        <!-- Heading -->
        <h2
            class="text-xl sm:text-2xl md:text-3xl text-[var(--text-secondary)] text-center mx-auto font-semibold -mt-4 sm:-mt-6 md:-mt-7 mb-4 px-2">
            <span class="font-bold">Meet Nuxt.store:</span> The best in class truly headless storefront
        </h2>
        <p class="text-base sm:text-lg md:text-xl text-[var(--text-gray)] max-w-5xl text-center mx-auto mb-10 px-2">
            Our premium frontend is exclusively crafted for seamless integration with our open-source backend.
            Elevate both customer experience and vendor empowerment with a robust, beautifully designed interface.
        </p>

        <!-- Feature Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
            <NsFeatureCard v-for="feature in features" :key="feature.title" :title="feature.title"
                :description="feature.description" :icon="feature.icon" />
        </div>
    </section>
</template>

<script setup lang="ts">
const NsLogo = defineAsyncComponent(() => import('./NsLogo.vue'));
const NsFeatureCard = defineAsyncComponent(() => import('~/components/NsFeatureCard.vue'));
const NsRocket = defineAsyncComponent(() => import('~/components/atoms/features-icons/NsRocket.vue'));
const NsEmpowerGrowthIcon = defineAsyncComponent(() => import('~/components/atoms/features-icons/NsEmpowerGrowthIcon.vue'));
const NsVendorDashboardIcon = defineAsyncComponent(() => import('~/components/atoms/features-icons/NsVendorDashboardIcon.vue'));
const NsOptimizedSeoIcon = defineAsyncComponent(() => import('~/components/atoms/features-icons/NsOptimizedSeoIcon.vue'));
const NsSeemlessIntegrationIcon = defineAsyncComponent(() => import('~/components/atoms/features-icons/NsSeemlessIntegrationIcon.vue'));
const NsIntrutiveDesign = defineAsyncComponent(() => import('~/components/atoms/features-icons/NsIntrutiveDesign.vue'));

const features = [
    {
        title: "Seamless Customer Journeys",
        description: "A fast, engaging interface that drives satisfaction and boosts sales.",
        icon: NsRocket,
    },
    {
        title: "Empowering Growth",
        description: "Designed to create exceptional shopping experiences that enhance engagement.",
        icon: NsEmpowerGrowthIcon,
    },
    {
        title: "Comprehensive Vendor Dashboard",
        description: "Advanced tools to help vendors manage and grow their businesses.",
        icon: NsVendorDashboardIcon,
    },
    {
        title: "Technically Optimized for SEO",
        description: "Boost visibility and rankings with fast, structured, and search-friendly pages.",
        icon: NsOptimizedSeoIcon,
    },
    {
        title: "Seamless Integration",
        description: "Integrates effortlessly with any backend or third-party services.",
        icon: NsSeemlessIntegrationIcon,
    },
    {
        title: "Scalable & Intuitive Design",
        description: "Built to support businesses of all sizes with ease of use and scalability.",
        icon: NsIntrutiveDesign,
    },
];
</script>
